import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import './BlockHeading.scss';

function BlockHeading({ title, withResetButton = false, onResetClick = () => {} }) {
  const Title = title ? 'h3' : 'div';

  return (
    <div className="heading">
      <Title className="heading-title u-els-margin-none">{title}</Title>
      {withResetButton && (
        <ButtonWithIcon
          data-e2e="preferences-reset-to-default"
          type="link"
          size="small"
          linkIconSize="s"
          sprite="Undo"
          iconRight
          onClick={onResetClick}
          aria-label={title ? `Reset to default: ${title}` : undefined}
          className="heading-reset">
          Reset to default
        </ButtonWithIcon>
      )}
    </div>
  );
}

BlockHeading.propTypes = {
  title: PropTypes.string,
  withResetButton: PropTypes.bool,
  onResetClick: PropTypes.func,
};

export default BlockHeading;
